<template>
  <div class="log-detail" >
   111
  </div>
</template>

<script>
export default {
}
</script>

<style lang="scss" scoped>
.mar {
  margin:20px 0;
}
.retry-tips{
  display: inline-block;
  margin-left: 20px;
  vertical-align:top;
  line-height: 16px;
  cursor: default;
}
</style>
